export const Jiggly = ({ children }) => {
  return <>{children}</>;
};
